import { createContext, useState ,useEffect} from "react";

export const Chat = createContext()

export const ChatProvider =({children })=>{

    const [chats,setChat]=useState(true)
    const updateChat = (newUserData) => {

        setChat(newUserData); // This updates the userData in state
    };



    return <Chat.Provider value={{chats,updateChat}}>
        {children }
    </Chat.Provider>

}